import React from 'react';
import { Button } from "@/components/ui/button";
import { TableRow, TableCell } from "@/components/ui/table";
import { CalendarDays, Clock, Pin, PinOff } from 'lucide-react';
import { Report } from '@/types/report';
import { formatDate } from '@/utils/reportFormatters';

interface PreviousReportTableRowProps {
  report: Report;
  onTogglePin: (report: Report) => void;
  isSelected: boolean;
  onRowClick: (reportId: string) => void;
}

export const PreviousReportTableRow: React.FC<PreviousReportTableRowProps> = ({ 
  report, 
  onTogglePin, 
  isSelected,
  onRowClick
}) => {

  const rowClassName = isSelected 
    ? "bg-form-lightest-blue border-2 !border-form-light-blue hover:bg-form-lightest-blue/90 cursor-pointer [&]:!border-2" 
    : (report.pinned ? "bg-muted/30 hover:bg-muted/40 cursor-pointer" : "hover:bg-muted/20 cursor-pointer");

  return (
    <TableRow key={report.id} className={rowClassName} onClick={() => onRowClick(report.id)}>
      <TableCell className="w-10" onClick={(e) => {
          e.stopPropagation();
          onTogglePin(report);
        }}>
        <Button variant="ghost" size="icon" title={report.pinned ? "นำออกจากรายการที่ปักหมุด" : "เพิ่มเข้ารายการที่ปักหมุด"}>
          {report.pinned ? (
            <Pin className="h-4 w-4 text-primary fill-primary" />
          ) : (
            <PinOff className="h-4 w-4 text-muted-foreground" />
          )}
        </Button>
      </TableCell><TableCell>
        <div className="flex items-center">
          <CalendarDays className="mr-2 h-4 w-4 text-muted-foreground" />
          {formatDate(report.teaching_date)}
        </div>
        {report.teaching_time_slot && (
          <div className="flex items-center text-xs text-muted-foreground mt-1">
            <Clock className="mr-1 h-3 w-3" />
            {report.teaching_time_slot}
          </div>
        )}
      </TableCell><TableCell>
        <div className="font-medium">{report.student_nickname || ''}</div>
        <div className="text-xs text-muted-foreground">{report.student_full_name || ''}</div>
      </TableCell><TableCell>{report.subject || ''}</TableCell>
    </TableRow>
  );
};
